export default {
  Awesome: {
    en: 'Awesome',
    ja: 'Awesome',
    et: 'Vinge',
    lt: 'Puiku, pavyko',
    ph: 'Awesome',
    ch: 'Awesome',
  },
  Sweet: {
    en: 'Sweet',
    ja: 'Sweet',
    et: 'Äge',
    lt: 'Nuostabu',
    ph: 'Sweet',
    ch: 'Sweet',
  },
  Nice: {
    en: 'Nice',
    ja: 'Nice',
    et: 'Lahe',
    lt: 'Gerai!',
    ph: 'Nice',
    ch: 'Nice',
  },
  'Good news': {
    en: 'Good news',
    ja: 'Good news',
    et: 'Tubli',
    lt: 'Geros naujienos',
    ph: 'Good news',
    ch: 'Good news',
  },
  Excellent: {
    en: 'Excellent',
    ja: 'Excellent',
    et: 'Suurepärane',
    lt: 'Puikiai',
    ph: 'Excellent',
    ch: 'Excellent',
  },
  Woo: {
    en: 'Woo',
    ja: 'Woo',
    et: 'Juhuu',
    lt: 'Valio',
    ph: 'Woo',
    ch: 'Woo',
  },
  Yeah: {
    en: 'Yeah',
    ja: 'Yeah',
    et: 'Jee',
    lt: 'Taip!',
    ph: 'Yeah',
    ch: 'Yeah',
  },
  Yay: {
    en: 'Yay',
    ja: 'Yay',
    et: 'Jei',
    lt: 'Valio!',
    ph: 'Yay',
    ch: 'Yay',
  },
  Hooray: {
    en: 'Hooray',
    ja: 'Hooray',
    et: 'Hurraa',
    lt: 'Sveikinimai!',
    ph: 'Hooray',
    ch: 'Hooray',
  },
  Fantastic: {
    en: 'Fantastic',
    ja: 'Fantastic',
    et: 'Super',
    lt: 'Fantastiška',
    ph: 'Fantastic',
    ch: 'Fantastic',
  },
  Gnarly: {
    en: 'Gnarly',
    ja: 'Gnarly',
    et: 'Nõme',
    lt: 'Super',
    ph: 'Gnarly',
    ch: 'Gnarly',
  },
  Epic: {
    en: 'Epic',
    ja: 'Epic',
    et: 'Totter',
    lt: 'Nerealu',
    ph: 'Epic',
    ch: 'Epic',
  },
  Bummer: {
    en: 'Bummer',
    ja: 'Bummer',
    et: 'Jama',
    lt: 'Užjaučiam',
    ph: 'Bummer',
    ch: 'Bummer',
  },
  Dang: {
    en: 'Dang',
    ja: 'Dang',
    et: 'Narrikas',
    lt: 'Et, nepavyko',
    ph: 'Dang',
    ch: 'Dang',
  },
  'Bad news': {
    en: 'Bad news',
    ja: 'Bad news',
    et: 'Jamps',
    lt: 'Blogos žinios',
    ph: 'Bad news',
    ch: 'Bad news',
  },
  Bonkers: {
    en: 'Bonkers',
    ja: 'Bonkers',
    et: 'Tobe',
    lt: 'Išprotėjimas!',
    ph: 'Bonkers',
    ch: 'Bonkers',
  },
  newBadge: {
    en: 'You just got the <1>{{name}}</1> badge.',
    ja: 'You just got the <1>{{name}}</1> badge.',
    et: 'Teenisid just <1>{{name}}</1> märgi.',
    lt: 'Tik ką gavai <1>{{name}}</1> ženkliuką.',
    ph: 'You just got the <1>{{name}}</1> badge.',
    ch: 'You just got the <1>{{name}}</1> badge.',
  },
  newChallenge: {
    en: 'You have just completed the <1>{{name}}</1> challenge.',
    ja: 'You have just completed the <1>{{name}}</1> challenge.',
    et: 'You have just completed the <1>{{name}}</1> challenge.',
    lt: 'You have just completed the <1>{{name}}</1> challenge.',
    ph: 'You have just completed the <1>{{name}}</1> challenge.',
    ch: 'You have just completed the <1>{{name}}</1> challenge.',
  },
  lostBadge: {
    en: 'Looks like you lost the <1>{{name}}</1> badge.',
    ja: 'Looks like you lost the <1>{{name}}</1> badge.',
    et: 'Jäid ilma märgist <1>{{name}}</1>.',
    lt: 'Atrodo, kad netekai <1>{{name}}</1> ženkliuko.',
    ph: 'Looks like you lost the <1>{{name}}</1> badge.',
    ch: 'Looks like you lost the <1>{{name}}</1> badge.',
  },
  lostChallenge: {
    en: 'Looks like the approval of the <1>{{name}}</1> challenge is withdrawn.',
    ja: 'Looks like the approval of the <1>{{name}}</1> challenge is withdrawn.',
    et: 'Looks like the approval of the <1>{{name}}</1> challenge is withdrawn.',
    lt: 'Looks like the approval of the <1>{{name}}</1> challenge is withdrawn.',
    ph: 'Looks like the approval of the <1>{{name}}</1> challenge is withdrawn.',
    ch: 'Looks like the approval of the <1>{{name}}</1> challenge is withdrawn.',
  },
  likeComment: {
    en: '<0>{{name}}</0> liked your comment.',
    ja: '<0>{{name}}</0> liked your comment.',
    et: '<0>{{name}}</0>-le meedlis su kommentaar.',
    lt: '<0>{{name}}</0> pamėgo tavo komentarą.',
    ph: '<0>{{name}}</0> liked your comment.',
    ch: '<0>{{name}}</0> liked your comment.',
  },
  replyComment: {
    en: '<0>{{name}}</0> replied your comment.',
    ja: '<0>{{name}}</0> replied your comment.',
    et: '<0>{{name}}</0> vastas su kommentaarile',
    lt: '<0>{{name}}</0> atsakė į tavo komentarą.',
    ph: '<0>{{name}}</0> replied your comment.',
    ch: '<0>{{name}}</0> replied your comment.',
  },
  badgeApprove: {
    en: 'The badge(s) you chose for your project, <1>{{projectName}}</1>, were approved by <3>{{userName}}</3>.',
    ja: 'The badge(s) you chose for your project, <1>{{projectName}}</1>, were approved by <3>{{userName}}</3>.',
    et: '<3>{{userName}}</3> kinnitas sinu valitud märgid projektile <1>{{projectName}}</1>.',
    lt: 'Ženkliuką/us, kurį pasirinkai savo projektui <1>{{projectName}}</1>, patvirtino <3>{{userName}}</3>.',
    ph: 'The badge(s) you chose for your project, <1>{{projectName}}</1>, were approved by <3>{{userName}}</3>.',
    ch: 'The badge(s) you chose for your project, <1>{{projectName}}</1>, were approved by <3>{{userName}}</3>.',
  },
  badgeReject: {
    en: 'Looks like the badge(s) you chose for your project, <1>{{name}}</1>, were rejected.',
    ja: 'Looks like the badge(s) you chose for your project, <1>{{name}}</1>, were rejected.',
    et: 'Paaistab, et märgid su projektile <1>{{name}}</1> ei leidnud kinnitust.',
    lt: 'Atrodo, kad ženkliukas/ai, kurį pasirinkai savo projektui <1>{{name}}</1>, buvo atmestas. ',
    ph: 'Looks like the badge(s) you chose for your project, <1>{{name}}</1>, were rejected.',
    ch: 'Looks like the badge(s) you chose for your project, <1>{{name}}</1>, were rejected.',
  },
  projectComment: {
    en: '<0>{{userName}}</0> commented on your project, <2>{{projectName}}</2>',
    ja: '<0>{{userName}}</0> commented on your project, <2>{{projectName}}</2>',
    et: '<0>{{userName}}</0> kommenteeris su projekti <2>{{projectName}}</2>.',
    lt: '<0>{{userName}}</0> pakomentavo tavo projektą <2>{{projectName}}</2>',
    ph: '<0>{{userName}}</0> commented on your project, <2>{{projectName}}</2>',
    ch: '<0>{{userName}}</0> commented on your project, <2>{{projectName}}</2>',
  },
  projectLike: {
    en: '<0>{{userName}}</0> liked your project, <2>{{projectName}}</2>',
    ja: '<0>{{userName}}</0> liked your project, <2>{{projectName}}</2>',
    et: '<0>{{userName}}</0>-le meeldis su projekt <2>{{projectName}}</2>',
    lt: '<0>{{userName}}</0> pamėgo tavo projektą <2>{{projectName}}</2>',
    ph: '<0>{{userName}}</0> liked your project, <2>{{projectName}}</2>',
    ch: '<0>{{userName}}</0> liked your project, <2>{{projectName}}</2>',
  },
  'Try another badge': {
    en: 'Try another badge',
    ja: 'Try another badge',
    et: 'Proovi teist märki',
    lt: 'Pabandyk kitą ženkliuką',
    ph: 'Try another badge',
    ch: 'Try another badge',
  },
  'New Notifications': {
    en: 'New Notifications',
    ja: 'New Notifications',
    et: 'Uued teavitused',
    lt: 'Nauji pranešimai',
    ph: 'New Notifications',
    ch: 'New Notifications',
  },
  'There are no new notifications!': {
    en: 'There are no new notifications!',
    ja: 'There are no new notifications!',
    et: 'Uusi teavitusi pole.',
    lt: 'Nėra naujų pranešimų',
    ph: 'There are no new notifications!',
    ch: 'There are no new notifications!',
  },
  'Other Notifications': {
    en: 'Other Notifications',
    ja: 'Other Notifications',
    et: 'Muud teavitused',
    lt: 'Kiti pranešimai',
    ph: 'Other Notifications',
    ch: 'Other Notifications',
  },
  'There are no notifications!': {
    en: 'There are no notifications!',
    ja: 'There are no notifications!',
    et: 'Teavitusi pole.',
    lt: 'Nėra pranešimų!',
    ph: 'There are no notifications!',
    ch: 'There are no notifications!',
  },
  starterCriteriaCompletion: {
    en: 'You are now a VIVINAUT and welcome to the VIVITA family!',
    ja: 'You are now a VIVINAUT and welcome to the VIVITA family!',
    et: 'You are now a VIVINAUT and welcome to the VIVITA family!',
    lt: 'You are now a VIVINAUT and welcome to the VIVITA family!',
    ph: 'You are now a VIVINAUT and welcome to the VIVITA family!',
    ch: 'You are now a VIVINAUT and welcome to the VIVITA family!',
  },
  walletActivated: {
    en: 'Your wallet has been successfully created!',
    ja: 'Your wallet has been successfully created!',
    et: 'Your wallet has been successfully created!',
    lt: 'Your wallet has been successfully created!',
    ph: 'Your wallet has been successfully created!',
    ch: 'Your wallet has been successfully created!',
  },
};
